/* tslint:disable */
/* eslint-disable */
/**
 * Muisti API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ExhibitionPageEventTransition {
    Fade = 'fade'
}

export function ExhibitionPageEventTransitionFromJSON(json: any): ExhibitionPageEventTransition {
    return ExhibitionPageEventTransitionFromJSONTyped(json, false);
}

export function ExhibitionPageEventTransitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExhibitionPageEventTransition {
    return json as ExhibitionPageEventTransition;
}

export function ExhibitionPageEventTransitionToJSON(value?: ExhibitionPageEventTransition | null): any {
    return value as any;
}

